/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceCollabDraftRelevance = "LATEST" | "STALE" | "%future added value";
export type CollabDraftWithRelevanceQuery$variables = {
  draftShareId?: string | null;
  hydrateAdf?: boolean | null;
  id: string;
};
export type CollabDraftWithRelevanceQuery$data = {
  readonly collabDraft: {
    readonly document: string | null;
    readonly metadata: {
      readonly relevance: ConfluenceCollabDraftRelevance | null;
      readonly title: string | null;
    } | null;
    readonly version: number | null;
  } | null;
};
export type CollabDraftWithRelevanceQuery = {
  response: CollabDraftWithRelevanceQuery$data;
  variables: CollabDraftWithRelevanceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "draftShareId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hydrateAdf"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "draftShareId",
        "variableName": "draftShareId"
      },
      {
        "kind": "Variable",
        "name": "hydrateAdf",
        "variableName": "hydrateAdf"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CollabDraft",
    "kind": "LinkedField",
    "name": "collabDraft",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "document"
      },
      {
        "kind": "ScalarField",
        "name": "version"
      },
      {
        "concreteType": "CollabDraftMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "relevance"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CollabDraftWithRelevanceQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CollabDraftWithRelevanceQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
    "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
    "metadata": {},
    "name": "CollabDraftWithRelevanceQuery",
    "operationKind": "query",
    "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
  }
};
})();

(node as any).hash = "c0bfcca7b64103265224238d7c18d9b1";

export default node;
